import DateTime from 'components/content/DateTime';
import NoData from 'components/content/NoData';

interface DateTimeOrNoDataProps {
    value?: string | Date | null;
}

const toValidDate = (value?: string | Date | null): Date | undefined => {
    if (!value) {
        return;
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? undefined : date;
};

const DateTimeOrNoData = ({ value }: DateTimeOrNoDataProps) => {
    const date = toValidDate(value);

    return date ? (
        <p className='w-max flex-1-1'>
            <DateTime date={date} />
        </p>
    ) : (
        <NoData text='No data' className='flex-1-1 text-14' />
    );
};

export default DateTimeOrNoData;
